export default __webpack_public_path__ + "static/media/logo-text-white.0dc21e16.svg";